import type { AppTableColumn } from 'shared/UI/UIKit/Table';
import type { Organization } from 'services/api';

export const getOrganizationsTableColumns = (): AppTableColumn<Organization>[] => {
  const columns: AppTableColumn<Organization>[] = [
    {
      key: 'id',
      title: 'ID',
      dataIndex: ['id'],
      maxWidth: '10rem',
    },
    {
      key: 'name',
      title: 'Название организации',
      dataIndex: ['name'],
      maxWidth: '25rem',
    },
    {
      key: 'municipalityName',
      title: 'Муниципалитет',
      dataIndex: ['municipalityName'],
      maxWidth: '25rem',
    },
  ];

  return columns;
};
